/** 40px selection pill — filled vs outline */
export function Pill({ selected = false, children, className = '', ...rest }) {
  return (
    <button
      type="button"
      className={[
        'inline-flex min-h-[var(--motion-pill-height,40px)] items-center justify-center rounded-xl px-4 text-sm font-semibold transition-all',
        selected
          ? 'bg-[var(--brand-primary-cta)] text-[var(--text-on-primary)] shadow-sm'
          : 'bg-[var(--surface-card)] text-[var(--text-primary)] ring-1 ring-inset ring-[var(--border-subtle)]',
        className,
      ].join(' ')}
      {...rest}
    >
      {children}
    </button>
  );
}

/** PRO / SOON badges */
export function Badge({ variant = 'pro', children, className = '' }) {
  const styles = {
    pro: 'bg-[var(--brand-primary-cta)] text-[var(--text-on-primary)]',
    soon: 'bg-[color-mix(in_srgb,var(--brand-primary)_15%,var(--surface-card))] text-[var(--brand-orange-text)]',
  };
  return (
    <span
      className={[
        'inline-flex items-center rounded-md px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wide',
        styles[variant] ?? styles.pro,
        className,
      ].join(' ')}
    >
      {children}
    </span>
  );
}
